import { useLocation, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import navLinks from '../../../config/navLinks';
import "./Navbar.css"

function Navbar({ showSidebar }) {
    const location = useLocation();

    const { t } = useTranslation();

    return (
        <nav className="nav">
            <div className="container nav-container">
                <div className="nav-toggler" onClick={showSidebar}>
                    <button className="btn icon-btn nav-toggler d-block d-md-none">
                        <i className="bi bi-list text-white"></i>
                    </button>
                </div>
                <ul className="nav-links d-flex flex-row d-none d-md-flex">
                    {
                        navLinks.map((link) => {
                            return (
                                <Link key={link.label} to={link.path} className="nav-item text-decoration-none">
                                    <div className={`nav-link ${location.pathname === link.path ? "active" : ""}`}>
                                        {t(link.label)}
                                    </div>
                                </Link>
                            )
                        })
                    }
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;